import React from "react";
import { useNavigate } from "react-router-dom";

const ThankYouPage = () => {
  const navigate = useNavigate();

  return (
    <div className="fade-in" style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem",
      background: "var(--bg-dark)"
    }}>
      <div className="card" style={{
        maxWidth: "600px",
        width: "100%",
        textAlign: "center",
        padding: "3rem 2rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
        <div style={{
          fontSize: "5rem",
          marginBottom: "1.5rem",
          animation: "float 3s ease-in-out infinite"
        }}>
          🎉
        </div>

        <h1 style={{
          fontSize: "2.5rem",
          fontWeight: "700",
          marginBottom: "1rem",
          background: "linear-gradient(135deg, var(--success-green), var(--accent-cyan))",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text"
        }}>
          Assessment Complete!
        </h1>

        <p style={{
          color: "var(--text-secondary)",
          fontSize: "1.25rem",
          marginBottom: "2rem",
          lineHeight: "1.6"
        }}>
          Thank you for completing the psychometric assessment. Your responses have been successfully recorded.
        </p>

        <div style={{
          background: "rgba(16, 185, 129, 0.1)",
          border: "1px solid var(--success-green)",
          borderRadius: "8px",
          padding: "1rem",
          marginBottom: "2rem",
          width: "100%"
        }}>
          <p style={{ color: "var(--success-green)", fontWeight: "600" }}>
            ✓ Responses Submitted Successfully
          </p>
        </div>

        <button
          className="btn-primary"
          onClick={() => window.location.href = "/"}
          style={{ width: "100%", maxWidth: "300px" }}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default ThankYouPage;
